import React from "react";
import { rowsAbove } from "./rowUtils";

/**
 * 2px red "now" line drawn between the two block rows that bracket the current time.
 */
export default function NowLineOverlay({ nowRowIndex, rows, rowH, headerH = 32 }) {
  if (nowRowIndex < 0) return null;
  const top = headerH + rowsAbove(rows, nowRowIndex, rowH);
  return (
    <div className="now-line" style={{ top }}>
      <span className="absolute left-2 -top-3 mono text-2xs text-red uppercase tracking-widest bg-bg-base px-1">
        NOW
      </span>
    </div>
  );
}
